export function columnResize($event, numOfFrozenCols, table) {
    var colIndex = $event.element.cellIndex + 1;
    var change = $event.delta;

    var tableStyle = getComputedStyle(table);
    var width = tableStyle.getPropertyValue('width');
    var widthArr = width.split('p');
    var widthValue = widthArr[0];
    var newWidthValue = +widthValue + $event.delta;
    table.style.width = `${newWidthValue}px`;
    //expand
    if (colIndex <= numOfFrozenCols) {
        for (var i = colIndex; i < numOfFrozenCols; i++) {
            var columnTdCells = Array.from(
                table.querySelectorAll(`td:nth-child(${i})`)
            ) as Array<any>;
            for (var y = 0; y < columnTdCells.length; y++) {
                var style = getComputedStyle(columnTdCells[y].nextSibling);
                var left = style.getPropertyValue('left');
                var leftArr = left.split('p');
                var leftValue = leftArr[0];
                var newLeftValue;

                newLeftValue = +leftValue + change;
                columnTdCells[y].nextSibling.style.left = `${newLeftValue}px`;
            }
            var columnThCells = Array.from(
                table.querySelectorAll(`th:nth-child(${i})`)
            ) as Array<any>;
            for (var z = 0; z < columnThCells.length; z++) {
                var style = getComputedStyle(columnThCells[z].nextSibling);
                var left = style.getPropertyValue('left');
                var leftArr = left.split('p');
                var leftValue = leftArr[0];
                var newLeftValue;

                newLeftValue = +leftValue + change;
                columnThCells[z].nextSibling.style.left = `${newLeftValue}px`;
            }
        }
    }

    //fit
    // if (colIndex < numOfFrozenCols) {
    //     var columnTdCells = Array.from(table.querySelectorAll(`td:nth-child(${colIndex})`)) as Array<any>;
    //     for (var y = 0; y < columnTdCells.length; y++) {
    //         var style = getComputedStyle(columnTdCells[y].nextSibling);
    //         var left = style.getPropertyValue("left");
    //         var leftArr = left.split("p");
    //         var leftValue = leftArr[0];
    //         var newLeftValue;

    //         newLeftValue = +leftValue + change;
    //         columnTdCells[y].nextSibling.style.left = `${newLeftValue}px`;

    //     }
    //     var columnThCells = Array.from(table.querySelectorAll(`th:nth-child(${colIndex})`)) as Array<any>;
    //     for (var z = 0; z < columnThCells.length; z++) {
    //         var style = getComputedStyle(columnThCells[z].nextSibling);
    //         var left = style.getPropertyValue("left");
    //         var leftArr = left.split("p");
    //         var leftValue = leftArr[0];
    //         var newLeftValue;

    //         newLeftValue = +leftValue + change;
    //         columnThCells[z].nextSibling.style.left = `${newLeftValue}px`;

    //     }
    // }
}
